import React, { Component } from 'react';
import { Card, Typography,  Button  } from 'antd';
import { observer, inject } from 'mobx-react';
import { inputField, passwordField } from './InputElements';

const { Title, Text } = Typography;

const root = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
};

const loginCard = {
    height: '420px',
    display: 'flex',
    flex: 2,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',   
};

const messageContainer= {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 10,
}

const newLoginCardWrapperTable = {
    display: 'flex',
    flex: 2,
    justifyContent: 'center',
    flexDirection: 'row',
    alignItems: 'center',  
    paddingTop: '60px',
}

  const splitLeft = {
    height: '420px',
    width: '25%',
    display: 'inline-block',
    zIndex: '1',
    top: '0',
    overflowX: 'hidden',
    left: '10px',
    backgroundColor: '#111',
    borderRadius: "30px 0px 0px 30px",
    boxShadow: "15px 15px 5px grey",
  }

  const splitRight = {
    height: '420px',
    width: '25%',
    display: 'inline-block',
    zIndex: '1',
    top: '0',
    overflowX: 'hidden',
    right: '10px',
    backgroundColor: 'white',
    borderRadius: "0px 30px 30px 0px",
    boxShadow: "15px 15px 5px grey",
  }

  const im = require('../images/ASHP-.png');

@inject('appStore')
@observer
export default class LoginScreen extends Component {
    render() {
        const appStore = this.props.appStore;
        const loginStore = appStore.loginStore;
        const loginCredentials = loginStore.loginCredentials;

        return (
            <div style={root}>
                <div style={newLoginCardWrapperTable}>
                    <div style={newLoginCardWrapperTable}>
                        <div style={splitLeft}>
                            <div>
                                <img src={require('../images/actual_size.jpg')} style={{width: "100%",height:420,position: "relative"}}/>
                            </div>
                        </div>

                        <div style={splitRight}>
                            <Card style={loginCard} title={<Title level={2}>Login</Title>}>
                                {inputField('email', loginCredentials, true, 'loginField', 'Email')}
                                {passwordField('password', loginCredentials, true, 'loginField', 'Password')}
                                <Button loading={false} block type="primary" onClick={this.onSubmit}>Log in</Button>
                                <div style={messageContainer} >
                                    {this.renderMessage()}
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderMessage = () => {
        const store = this.props.appStore;
        const message = store.validationMessage;

        switch (store.state) {
            case 'error':
                {
                    return (
                        <Text type="danger" >{message}</Text>
                    )
                }
            case 'pending':
                {
                    return (
                        <Text type="warning" >{message}</Text>
                    )
                }
            case 'done':
                {
                    return (
                        <Text>{message}</Text>
                    )
                }
            default:
                {
                    return (
                        <Text>{message}</Text>
                    )
                }
        }

    }

    onSubmit = async () => {
        const store = this.props.appStore;
        await store.authenticate();
    };
}
